<template>
    <!-- >>> The Flight - Row -->
    <div class="details col-xs-9 col-sm-10">
        <!-- >>> The Flight - Row -->
        <div class="details-wrapper">
            <!-- >>> First Row -->
            <div class="first-row">
                <div v-if="flightdirection === 'outward'">
                    <h4 class="box-title">{{ flight.depArprt.i }} {{ to[getCurrentLocale] }} {{ flight.desArprt.i }}<small>{{ whichFlightDirection(flight.depArprt.i) }} - {{ flight.no }}</small></h4>
                    <a class="button btn-mini silver" v-bind:class="{ yellow: get_RebookingFlightIdSelectedOutward === flight.id }" style="cursor: initial; outline: none !important; outline-style: none !important;">STOPS: {{ flight.stpArprt === null ? '0' : '1' }}</a>

                    <div class="amenities">  <!-- services off -->
                        <i class="soap-icon-passenger circle greychossen"></i>
                        <i class="soap-icon-fork circle greychossen"></i>
                        <i class="soap-icon-suitcase circle greychossen"></i>
                    </div>
                </div>
                <div v-if="flightdirection === 'return'">
                    <h4 class="box-title">{{ flight.depArprt.i }} {{ to[getCurrentLocale] }} {{ flight.desArprt.i }}<small>{{ whichFlightDirection(flight.depArprt.i) }} - {{ flight.no }}</small></h4>
                    <a class="button btn-mini silver" v-bind:class="{ yellow: get_RebookingFlightIdSelectedReturn === flight.id }" style="cursor: initial; outline: none !important; outline-style: none !important;">STOPS: {{ flight.stpArprt === null ? '0' : '1' }}</a>

                    <div class="amenities">  <!-- services off -->
                        <i class="soap-icon-passenger circle greychossen"></i>
                        <i class="soap-icon-fork circle greychossen"></i>
                        <i class="soap-icon-suitcase circle greychossen"></i>
                    </div>
                </div>
                <div>
                    <!-- >>> Flight - NOT 'SOLD OUT' -->
                    <span class="price" v-if="flight.prcs[0] !== undefined">
                        <a class="collapsed" v-bind:href="'#acc' + flight.id" data-toggle="collapse" v-bind:data-parent="'#accordion' + flight.id" v-tooltip="seetaxes[getCurrentLocale]">
                            <small>{{ avgpers[getCurrentLocale] }}</small>{{ Number(flight.prcs[0].amnt) + Number(flight.prcs[0].tax.tot) | rndAmntRUAFWZ }}
                        </a>
                    </span>
                    <!-- >>> Flight - 'SOLD OUT' -->
                    <span class="price" style="color: #D9D9D8; text-transform: none;" v-if="flight.prcs[0] === undefined">
                        <small style="color: #D9D9D8;">{{ avgpers[getCurrentLocale] }}</small><span style="color: rgb(142, 142, 142);">{{ out[getCurrentLocale] }}</span>
                    </span>
                </div>
            </div>
            <!-- <<< First Row -->

            <!-- >>> Second Row -->
            <div class="second-row">
                <!-- >>> Times -->
                <div class="time">
                    <div class="take-off col-sm-4">
                        <div class="icon">
                            <i class="soap-icon-plane-right yellow-color"></i>
                        </div>
                        <div>
                            <span class="skin-color-srvcs">{{ takeoff[getCurrentLocale] }}</span>
                            <br>
                            {{ flight.depDT | moment }}
                        </div>
                    </div>
                    <div class="landing col-sm-4">
                        <div class="icon">
                            <i class="soap-icon-plane-right yellow-color"></i>
                        </div>
                        <div>
                            <span class="skin-color-srvcs">{{ landing[getCurrentLocale] }}</span>
                            <br>
                            {{ flight.desDT | moment }}
                        </div>
                    </div>
                    <div class="total-time col-sm-4">
                        <div class="icon">
                            <i class="soap-icon-clock yellow-color"></i>
                        </div>
                        <div>
                            <span  class="skin-color-srvcs">{{ totaltime[getCurrentLocale] }}</span>
                            <br>
                            {{ flight.dur | durationFlight }}
                        </div>
                    </div>
                </div>
                <!-- <<< Times -->

                <!-- >>> 'Select Flight' Button(s)  -->
                <!-- Button: ON/SELECTED -->
                <div class="action" v-if="flight.prcs[0] !== undefined && flightdirection === 'outward'">
                    <!-- Button: ON -->
                    <a href="#" @click.prevent="onClick_SelectFlight({ flight: flight, type: 'outward' })"
                        class="button btn-small full-width xgreen" v-if="get_RebookingFlightIdSelectedOutward !== flight.id">
                        {{ selectflight[getCurrentLocale] }}
                    </a>
                    <!-- Button: SELECTED -->
                    <a class="button btn-small full-width sundair" v-if="get_RebookingFlightIdSelectedOutward === flight.id">{{ selectflight[getCurrentLocale] }}</a>
                </div>

                <div class="action" v-if="flight.prcs[0] !== undefined && flightdirection === 'return'">
                    <!-- Button: ON -->
                    <a href="#" @click.prevent="onClick_SelectFlight({ flight: flight, type: 'return' })"
                        class="button btn-small full-width xgreen" v-if="get_RebookingFlightIdSelectedReturn !== flight.id">
                        {{ selectflight[getCurrentLocale] }}
                    </a>
                    <!-- Button: SELECTED -->
                    <a class="button btn-small full-width sundair" v-if="get_RebookingFlightIdSelectedReturn === flight.id">{{ selectflight[getCurrentLocale] }}</a>
                </div>

                <!-- Button: OFF/OUT -->
                <div class="action" v-if="flight.prcs[0] === undefined">
                    <a class="button btn-small full-width silver" style="color: rgba(0,0,0,.075); background: #F9F9F9;">{{ selectflight[getCurrentLocale] }}</a>
                </div>
                <!-- <<< 'Select Flight' Button(s)  -->
            </div>
            <!-- <<< Second Row -->
        </div>
        <!-- <<< The Flight - Row -->


        <!-- >>> Taxes - Row -->
        <div class="row" style="margin-bottom: 0px;" v-if="flight.prcs[0] !== undefined">
            <div class="toggle-container" v-bind:id="'accordion' + flight.id">
                <div class="panel">
                    <div class="panel-collapse collapse" v-bind:id="'acc' + flight.id">
                        <div class="panel-content" style="padding-top: 0px; padding-left: 15px;">
                            <hr>
                            <h4 class="box-title">{{ taxesandfees[getCurrentLocale] }}:</h4>
                            <br /><br />
                            <div class="" style="padding: 0px; padding-right: 10px; margin-bottom: 0px; width:50%;">
                                <ul class="" style="margin-bottom: 0px; font-size: 0.8333em;">
                                    <li class="skin-color uppercase">{{ airfare[getCurrentLocale] }}: <span class="pull-right">{{ Number(flight.prcs[0].amnt) | rndAmntRUAFWZ }}</span></li>
                                    <li class="skin-color uppercase">{{ airporttaxes[getCurrentLocale] }}: <span class="pull-right">{{ flight.prcs[0].tax.air | rndAmntRUAFWZ }}</span></li>
                                    <li class="skin-color uppercase">{{ aviationtax[getCurrentLocale] }}: <span class="pull-right">{{ flight.prcs[0].tax.avia | rndAmntRUAFWZ }}</span></li>
                                    <li class="skin-color uppercase">{{ kerosenesurcharge[getCurrentLocale] }}: <span class="pull-right">{{ flight.prcs[0].tax.fuel | rndAmntRUAFWZ }}</span></li>
                                    <li class="skin-color uppercase">{{ securitycharges[getCurrentLocale] }}: <span class="pull-right">{{ flight.prcs[0].tax.sec | rndAmntRUAFWZ }}</span></li>
                                    <li class="skin-color uppercase">{{ servicecharges[getCurrentLocale] }}: <span class="pull-right">{{ flight.prcs[0].tax.srvc | rndAmntRUAFWZ }}</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <<< Taxes - Row -->
    </div>
    <!-- <<< The Flight - Row -->
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import moment from 'moment';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['flight', 'flightdirection'], // mode: 'overview', 'rebookingpassengers'
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

        }, // eo components
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                outwardflight: {
                    en: 'Outward Flight',
                    de: 'Hinflug',
                },
                returnflight: {
                    en: 'Return Flight',
                    de: 'Rückflug',
                },
                selectflight: {
                    en: 'SELECT FLIGHT',
                    de: 'FLUG WÄHLEN',
                },
                // ----------------------------------------
                soldoutsrvcs: {
                    en: 'Your Flight!',
                    de: 'Ihr Flug!',
                },
                taxesandfees: {
                    en: 'Taxes and Fees',
                    de: 'Steuern und Gebühren'
                },
                out: {
                    en: 'SOLD OUT',
                    de: 'AUSV.'
                },
                // ----------------------------------------
                selectbookedflight: {
                    en: 'MY NEW FLIGHT',
                    de: 'MEIN NEUER FLUG',
                },
                // ----------------------------------------
                takeoff: {
                    en: 'Take off',
                    de: 'Abflug',
                },
                landing: {
                    en: 'Landing',
                    de: 'Ankunft',
                },
                totaltime: {
                    en: 'total time',
                    de: 'Dauer',
                },
                to: {
                    en: 'to',
                    de: 'nach',
                },
                // ----------------------------------------
                amenities_services: {
                    en: 'Additional services can be reserved on this flight: Seats' ,
                    de: 'Auf diesem Flug sind Zusatzleistungen reservierbar: Sitzplätze',
                },
                amenities_meal: {
                    en: 'Additional services can be reserved on this flight.: Meals',
                    de: 'Auf diesem Flug sind Zusatzleistungen reservierbar: Essen',
                },
                amenities_lugagge: {
                    en: 'Additional services can be reserved on this flight.: Additional Luggage',
                    de: 'Auf diesem Flug sind Zusatzleistungen reservierbar: Zusätzliches Gepäck',
                },
                // ----------------------------------------
                isthisyourflight: {
                    en: 'Your Flight?',
                    de: 'Ihr Flug?',
                },
                thisismyflight: {
                    en: 'Yes, my Flight',
                    de: 'Ja, mein Flug',
                },
                thisis: {
                    en: 'Is this',
                    de: 'Ist das',
                },
                seetaxes: {
                    en: 'See Taxes & Fees',
                    de: 'Steuern & Gebühren ansehen',
                },
                // ----------------------------------------
                taxesandfees: {
                    en: 'Taxes and Fees',
                    de: 'Steuern und Gebühren'
                },
                airfare: {
                    en: 'Airfare',
                    de: 'Flugpreis'
                },
                airporttaxes: {
                    en: 'Airport taxes',
                    de: 'Flughafengebühren'
                },
                aviationtax: {
                    en: 'Aviation tax',
                    de: 'Luftverkehrssteuer'
                },
                kerosenesurcharge: {
                    en: 'Kerosene surcharge',
                    de: 'Kerosinzuschlag'
                },
                securitycharges: {
                    en: 'Security charges',
                    de: 'Sicherheitsgebühren'
                },
                servicecharges: {
                    en: 'Service charges',
                    de: 'Servicegebühren'
                },
                // ----------------------------------------
                avgpers: {
                    en: 'AVG/PERSON',
                    de: 'PRO PERSON'
                },
            };

        }, // eo data
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'get_RebookingFlightIdSelectedOutward',
                'get_RebookingFlightIdSelectedReturn',
                'getRebookingDepArprtCode'
            ]),

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Filters */
        filters: {

            /*******************************************************************
            * durationFlight()
            *
            * Desc: Calculates "Travel Time".
            *
            * @param {int} a (duration in seconds)
            * @return {string}
            */
            durationFlight: function(a) {

                let hours = Math.floor(a / 3600),
                    minutes = Math.floor(a / 60) - hours * 60,
                    hours_txt = 'S', // H
                    minutes_txt = ' h'; // M


                if (minutes === 0) {
                    return hours + ':00' + minutes_txt;
                } else if (minutes.toString().length === 1) {
                    return hours + ':0' + minutes + '' + minutes_txt;
                } else {
                    return hours + ':' + minutes + '' + minutes_txt;
                }

            }, // eof durationFlight()

        }, // eof filters{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_setRebookingUpdateCart'
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onClick_SelectFlight()
            *
            * Desc: Flight selected! Call ACTION(s)!
            * Note: Param 'flight' has ..  'flight', 'type', 'modulo'.
            * Note: Watches 'modulo'!
            *
            * @param {Object} flight (selected Flight)
            * @return {string}
            */
            onClick_SelectFlight: function(flight) {

                var me = this;


                me.$toc('>>> rebooking/flightsearchresults/Flight.vue >>> onClick_SelectFlight');
                this.actn_setRebookingUpdateCart(flight); // watch what all happens in there ...

            }, // eof onClick_SelectFlight()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * whichFlightDirection()
            *
            * Desc:
            *
            * @param {string} apt (Airports)
            * @return {string}
            */
            whichFlightDirection: function(apt) {

                var me = this;


                me.$toc('>>> rebooking/flightsearchresults/Flight.vue >>> whichFlightDirection');
                if (this.getRebookingDepArprtCode && apt === this.getRebookingDepArprtCode) {
                    return this.outwardflight[this.getCurrentLocale];
                } else {
                    return this.returnflight[this.getCurrentLocale];
                }

            }, // eof whichFlightDirection()

        }, // eo methods
        /* <<< ****************************************************************/

    };
</script>

<style scoped>

    .tab-container .tab-content .tab-pane {
        padding: 0px;
    }
    .tab-container .tab-content {
        background: none;
    }
    .tab-container .tab-content .tab-pane .row {
        margin-bottom: 1px;
    }
    .pricing-table {
        padding: 0px;
        padding-top: 15px;
        padding-bottom: 0px;
        background: none;
    }
    .pricing-table {
        padding: 0px;
        padding-top: 15px;
        padding-bottom: 0px;
        background: none;
    }


    .tab-container.style1 ul.tabs li.active > a, .tab-container.style1 ul.tabs li:hover > a {
        color: #fff;
        background: #ab3a7a;
        position: relative;
    }
    .tab-container.style1 ul.tabs.srvcs li.active_rebooking > a, .tab-container.style1 ul.tabs.srvcs li:hover > a {
        color: #fff;
        background: #fdb714;
        position: relative;
    }
    .tab-container.style1 ul.tabs.srvcs li.active_rebooking > a:after, .tab-container.style1 ul.tabs.srvcs li:hover > a:after {
        position: absolute;
        bottom: -5px;
        left: 50%;
        margin-left: -10px;
        border-top: 5px solid #fdb714;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        content: "";
    }

    .icon-check3 {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check3:after {
        content: "";
        position: absolute;
        top: 0;
        right: 10px;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #4A6E89;
    }


    .topDistance {
        margin-top: 25px;
    }


    a.button:hover {
        background: #fdb714;
    }
</style>